import * as mqtt from 'mqtt';
import { IClientOptions, MqttClient } from 'mqtt';
import * as logger from '../logging/logger';

let client: MqttClient;
let isConnected = false;

let settings = {
    sessionId: '',
    brokerUrl: '',
    username: '',
    password: ''
}

interface MQTTClientOptions {
    sessionId: string;
    brokerUrl: string;
    username: string;
    password: string;
}

export function configure(options: MQTTClientOptions) {
    settings = {
        ...settings,
        ...options
    }
}

export function init() {
    const protocol = settings.brokerUrl.split('://')[0];

    const options = {
        protocol,
        clean: false,
        keepalive: 10,
        clientId: settings.sessionId,
        username:settings.username,
        password:settings.password,
    } as IClientOptions;

    try
    {
        client = mqtt.connect(settings.brokerUrl, options);

        client.on('connect', () => {
            isConnected = true;
            logger.log('Info', `MQTT: Connected to ${settings.brokerUrl}`);
        });

        client.on('close', () => {
            if (isConnected) {
                isConnected = false;
                logger.log('Info', 'MQTT: Connection closed');
            }
        });

        client.on('disconnect', () => {
            logger.log('Info', 'MQTT: Disconnected');
        });

        client.on('offline', () => {
            logger.log('Info', 'MQTT: Offline');
        });

        client.on('error', err => {
            logger.log('Error', `MQTT:Error ${err.message}`);
        });

        client.on('end', () => {
            logger.log('Info', 'MQTT: end');
        });
    } catch (err) {
        logger.log('Error', `MQTT: ${err.message}`);
    }

    logger.log(
        'Info',
        `MQTT: InitializedClient: protocol:${options.protocol} clean:${options.clean} keepalive:${options.keepalive} clientId:${options.clientId}`
    );
}

export function subscribe(topic: string) {
    /* istanbul ignore else  */
    if (client) {
        client.subscribe(topic, err => {
            if (err) {
                logger.log('Error', `MQTT: Error Subscribing to ${topic}`);
            } else {
                logger.log('Info', `MQTT: Subscribed to ${topic}`);
            }
        });
    }
}

export function unsubscribe(topic: string) {
    /* istanbul ignore else  */
    if (client) {
        client.unsubscribe(topic, () => {
            logger.log('Info', `MQTT: Unsubscribed from ${topic}`);
        });
    }
}

export function onMessage(callback: (topic: string, message: JSON) => void) {
    /* istanbul ignore else  */
    if (client) {
        client.on('message', (topic: string, message: any) => {
            try {
                const json = JSON.parse(message);

                if (json.changedBy && json.changedBy === settings.sessionId) {
                    logger.log(
                        'Debug',
                        `MQTT: MessageIgnoredByOriginator ${topic} entityType:${json.entityType} changeType:${json.changeType} changedBy:${json.changedBy}`
                    );
                    return;
                }

                if (json.entityType) {
                    logger.log(
                        'Info',
                        `MQTT: MessageReceived ${topic} entityType:${json.entityType} changeType:${json.changeType} changedBy:${json.changedBy}`
                    );
                } else {
                    logger.log('Info', `MQTT: MessageReceived ${topic}`);
                }
                callback(topic, json);
            } catch {
                logger.log('Error', `MQTT: Unable to parse message for ${topic}!!`);
            }
        });
    }
}

export function publishMessage(topic: string, message: any) {
    if (client) {
        logger.log(
            'Info',
            `MQTT: MessageSent ${topic}`
        );
        client.publish(topic, JSON.stringify(message));
    }
}
